import { useEffect, useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useConfig() {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    axios
      .get(`${API}/config`)
      .then((r) => setConfig(r.data))
      .catch((e) => setError(e));
  }, []);
  return { config, error };
}

export const eur = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v);

export const PHONE = "07 69 27 60 21";
export const PHONE_TEL = "tel:+33769276021";
